import { useState } from "react";
// Components
import Header from "./components/Header";
import PlayGround from "./components/PlayGround";
import Button from "./components/Button";
import Rules from "./components/Rules";
// Styled
import styled from "styled-components";

const App = () => {
  const [score, setScore] = useState(
    Number(localStorage.getItem("score")) || 0
  );
  const [isVisibleRules, setIsVisibleRules] = useState(false);

  const updateScore = (value) => {
    setScore(value);
    localStorage.setItem("score", value);
  };

  return (
    <AppStyled>
      <Container>
        <Content>
          <Header score={score} />
          <PlayGround updateScore={updateScore} score={score} />
          <div className="button-container">
            <Button onClick={() => setIsVisibleRules(true)}>RULES</Button>
          </div>
          <Rules
            isVisibleRules={isVisibleRules}
            setIsVisibleRules={setIsVisibleRules}
          />
        </Content>
      </Container>
    </AppStyled>
  );
};

export default App;

const AppStyled = styled.main`
  background: radial-gradient(
    circle at top,
    hsl(214, 47%, 23%) 0,
    hsl(237, 49%, 15%) 100%
  );
  overflow: hidden;
`;

const Container = styled.div`
  max-width: 650px;
  margin: auto;
`;

const Content = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5rem;
  .button-container {
    text-align: center;
    @media screen and (min-width: 1024px) {
      button {
        position: fixed;
        bottom: 2rem;
        right: 2rem;
      }
    }
  }
`;
